/** @format */

import {Component, Input} from '@angular/core';
import {isNil} from 'lodash-es';

@Component({
  selector: 'app-heating-tag',
  templateUrl: './heating-tag.component.html',
  styleUrls: ['./heating-tag.component.scss'],
})
export class HeatingTagComponent {
  @Input()
  public display: 'full' | 'letter' = 'full';

  @Input('setpoint')
  public set setSetpoint(setpoint: number) {
    if (isNil(setpoint) || typeof setpoint !== 'number') {
      this.setpoint = null;
    } else {
      this.setpoint = Math.round(setpoint);
    }
  }
  public setpoint: number = null;

  @Input('value')
  public set setValue(value: number) {
    if (isNil(value) || typeof value !== 'number') {
      this.value = null;
      this.color = 'var(--ion-color-danger)';
    } else {
      this.value = Math.round(value);
      this.color =
        this.value < 18
          ? 'var(--ion-color-secondary)'
          : this.value > 25
          ? 'var(--ion-color-accent)'
          : 'var(--ion-color-danger)';
    }
  }
  public value: number | null = null;
  public color = 'var(--ion-color-danger)';

  constructor() {}
}
